export default "__VITE_ASSET__B4yF5Iej__"